<template>
  <div class="coll-ect">
    <div class="con-search">
      <van-field v-model="value" placeholder="搜索产品/文章/图文/视频" />
      <div class="s-icon">
        <img src="@/assets/publicImg/search.png" alt />
      </div>
    </div>
    <ul>
      <li
        @click="oncheckLi(item)"
        :class="checkLi==item?'li-sty li-check-sty':'li-sty'"
        v-for="item in liList"
        :key="item"
      >{{item}}</li>
    </ul>
    <product-record v-if="checkLi=='产品'"></product-record>
    <article-record v-else></article-record>
  </div>
</template>

<script>
import ArticleRecord from './articleRecord.vue'
import productRecord from './productRecord.vue'
export default {
  components: { productRecord, ArticleRecord },
  data() {
    return {
      value: '',
      liList: ['产品', '文章/图文/视频'],
      checkLi: '产品',
    }
  },
  methods: {
    oncheckLi(item) {
      this.checkLi = item
    }
  }
}
</script>

<style lang="less" scoped>
.coll-ect {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  .con-search {
    width: 355px;
    height: 30px;
    margin: 7px auto 8px auto;
    background: url("../../assets/publicImg/search-bg.png") no-repeat 100%;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-cell {
      width: 300px;
      height: 30px;
      line-height: 30px;
      padding: 0 0 0 13px;
      background: transparent;
    }
    .s-icon {
      width: 40px;
      height: 30px;
      line-height: 27px;
      img {
        width: 14px;
        height: 14px;
        margin-left: 13px;
      }
    }
  }
  ul {
    display: flex;
    font-size: 14px;
    .li-sty {
      width: 188px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-weight: 400;
      color: #333333;
      background: url("../../assets/publicImg/li-bg1.png") no-repeat 100%;
      background-size: 100% 100%;
    }
    .li-check-sty {
      font-weight: 500;
      color: #fc6c21;
      background: url("../../assets/publicImg/li-bg5.png") no-repeat 100%;
      background-size: 100% 100%;
    }
  }
}
</style>